import { createSlice } from '@reduxjs/toolkit';
const SLICE_NAME = 'currentVehicle';

export const currentVehicleSlice = createSlice({
    name: SLICE_NAME,
    initialState: {
        data: '',
    },
    reducers: {
        setCurrentVehicle: (state, action) => {
            state.data = action.payload;
        },
    },
});

export const { setCurrentVehicle } = currentVehicleSlice.actions;

export const currentVehicleSelector = (state) =>
    state.commonData.currentVehicle.data;

export const currentVehicle = currentVehicleSlice.reducer;
